var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AssignmentItem } from "./AssignmentItem";
var AssignedLibraryAsset = /** @class */ (function (_super) {
    __extends(AssignedLibraryAsset, _super);
    function AssignedLibraryAsset() {
        return _super.call(this) || this;
    }
    Object.defineProperty(AssignedLibraryAsset.prototype, "AssetId", {
        get: function () {
            return this.assetId;
        },
        set: function (v) {
            this.assetId = v;
        },
        enumerable: true,
        configurable: true
    });
    return AssignedLibraryAsset;
}(AssignmentItem));
export { AssignedLibraryAsset };



// WEBPACK FOOTER //
// ./src/app/shared/models/AssignedLibraryAsset.ts.pre-build-optimizer.js